import { render, staticRenderFns } from "./TrxSingle.vue?vue&type=template&id=e06e322a&scoped=true&lang=pug"
import script from "./TrxSingle.vue?vue&type=script&lang=js"
export * from "./TrxSingle.vue?vue&type=script&lang=js"
import style0 from "./TrxSingle.vue?vue&type=style&index=0&id=e06e322a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06e322a",
  null
  
)

export default component.exports